const CACHE_KEY = 'bibleapp_questions_cache';
const TTL_MS    = 24 * 60 * 60 * 1000; // 24 h

export function saveToCache(questions) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), questions }));
  } catch {}
}

export function getFromCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { ts, questions } = JSON.parse(raw);
    return Date.now() - ts < TTL_MS ? questions : null;
  } catch { return null; }
}

export function isCacheValid() {
  return getFromCache() !== null;
}
